import React, { useState } from 'react';
import { Eye, Check, X, Download } from 'lucide-react';
import toast from 'react-hot-toast';
import { useSupabase } from '../../hooks/useSupabase';
import { abvigAPI } from '../../services/api';
import DataTable from '../../components/Tables/DataTable';
import { formatDate, getStatusColor, getStatusLabel } from '../../utils/helpers';

export default function InternApplications() {
  const { data, refetch } = useSupabase(abvigAPI.getInternApplications);
  const [processingId, setProcessingId] = useState(null);

  const handleStatusUpdate = async (id, status) => {
    setProcessingId(id);
    try {
      await abvigAPI.updateInternApplicationStatus(id, status);
      toast.success(`Application ${status} successfully`);
      refetch();
    } catch (error) {
      toast.error(`Failed to ${status} application`);
    } finally {
      setProcessingId(null);
    }
  };

  const columns = [
    { key: 'full_name', label: 'Full Name', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'phone', label: 'Phone' },
    { key: 'country', label: 'Country' },
    { key: 'position_applied', label: 'Position' },
    { 
      key: 'cv_url', 
      label: 'CV',
      render: (value) => value ? (
        <a 
          href={value} 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-red-600 hover:text-red-700"
        >
          <Download className="w-4 h-4" />
        </a>
      ) : '-'
    },
    { 
      key: 'status', 
      label: 'Status',
      render: (value) => (
        <span className={`badge ${getStatusColor(value)}`}>
          {getStatusLabel(value)}
        </span>
      )
    },
    { 
      key: 'created_at', 
      label: 'Applied',
      render: (value) => formatDate(value)
    },
  ];

  const actions = [
    {
      label: 'View',
      icon: <Eye className="w-4 h-4" />,
      onClick: (item) => console.log('View:', item),
      className: 'text-blue-600 hover:bg-blue-50',
      showWhen: ['pending', 'approved', 'rejected']
    },
    {
      label: 'Approve',
      icon: <Check className="w-4 h-4" />,
      onClick: (item) => handleStatusUpdate(item.id, 'approved'),
      className: 'text-green-600 hover:bg-green-50',
      showWhen: ['pending'],
      disabled: (item) => processingId === item.id
    },
    {
      label: 'Reject',
      icon: <X className="w-4 h-4" />,
      onClick: (item) => handleStatusUpdate(item.id, 'rejected'),
      className: 'text-red-600 hover:bg-red-50',
      showWhen: ['pending'],
      disabled: (item) => processingId === item.id
    },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Intern Applications</h1>
        <p className="text-gray-600">Manage internship applications</p>
      </div>

      <DataTable
        columns={columns}
        data={data || []}
        title={`Total: ${data?.length || 0} applications`}
        actions={actions}
        searchPlaceholder="Search applications..."
      />
    </div>
  );
}